




































































import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
  CANT_SEE_SECTION_MSG,
  CompanyID,
    formatDate,
    formatList,
    getCurrentTimestamp,
    getIndexFromList,
    getPropertyFromList,
    ID, matchedIndexIdInArray, OptionalCompany, parameterValueValidation, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment, { invalid } from 'moment';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, ParameterValue } from '../../../features/core/models/';
import { SettingsService } from '../api/SettingsService';
import { NormsServices } from '../../norms/api/NormsServices';
import { ecuIsNotScannerMsg, ecuIsScanner, ecuScanner } from '../../norms/utils';
import { JourneysService } from '../../journeys/api/JourneysService';
import { JourneysCalcTypes } from '../../journeys/models/Configuration';
import { CompaniesService } from '../api/CompaniesService';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SectionTitle,
        MultipleSelect,
        Input
    }
})
export default class ActivateJourneys extends Mixins(
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: -1}) companyId: number;
    modalTitle: string = 'Activación de Jornales';
    submitText: string = 'Activar';
    errorMsg: string = '';
    calcTypeSelected: object | null = null;
    calcTypeSelectedRv: boolean = false;
    calcTypes: Array<JourneysCalcTypes> = [];
    pendingRequest: boolean = false;

    created(){
        JourneysService.getJourneysCalcTypes(

        ).then((res: Array<JourneysCalcTypes>) => {
            this.calcTypes = res;
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudieron traer los tipos de cálculo')
        })
    }


    updateCalcTypeSelected(variable){
        this.calcTypeSelected = variable;
    }
    updateCalcTypeSelectedRv(text){
        this.calcTypeSelectedRv = text;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    activatingJourneys(value){
        this.pendingRequest = value;
    }

    submitAction(){
        if(this.calcTypeSelected !== null){
            this.activatingJourneys(true);
            CompaniesService.activateJourneys(
                this.companyId,
                {
                    calc_type: this.calcTypeSelected['value']
                }
            ).then((res) => {
                this.activatingJourneys(false);
                this.handleSuccessAction(res);
                this.updateHasActiveJourney(true);
                this.closeModal();
            }).catch((err) => {
                this.activatingJourneys(false);
                this.handleErrorAction(err, 'No se pudo activar el sistema de jornales');
            })
        }
    }

    @Emit()
    updateHasActiveJourney(value){return value}


    getData(){
        return {

        }
    }


    get formIsValid() {
        this.setErrorForm('');
        if(this.calcTypeSelected == null){
            this.setErrorForm('No seleccionó el tipo de cálculo');
            return false
        }
        return true
    }

    @Emit()
    closeModal() {}

    mounted() {
        this.$nextTick(() => {
           
        });
    }

    
}
